<div class="progress" *ngIf="loaded < 100; else load">
    <mat-progress-spinner [diameter]="width - width / 3" mode="determinate" [value]="loaded"></mat-progress-spinner>
    <span>{{ loaded }}%</span>
</div>
<ng-template #load>
    <img [class]="className" [ngClass]="{ avatar: avatar, error: hasError }" [src]="safeResourceUrl" [alt]="alt || 'Your Photo'" [width]="width" [height]="height">
</ng-template>